export const blogPosts = [
  {
    id: 1,
    title: "the bell jar",
    excerpt: "Sylvia Plath and myself",
    content: `
      <p>I got the incredible opportunity to read The bell jar as a sophomore at Reed College, during the gaps in my mornings taking care of flowers and plants at Reed in 2021. Yes, it was a summer job, which I cherish to this day, and quite frankly, I would love to be a farmer in another life. I love spending time physically laboring on nature a little bit too much. Perhaps another story for another day.</p>
      
      <p>I couldn't come back home over that summer, so I decided to get a campus job and read during my spare time. Perhaps the loneliness but forced contentment at the time was enough to enable me to appreciate every single aspect of the book. I have not read it since, but the impression of a perfect work of literary stayed with me ever since. I can only mention The bell jar during my most elated discussions of books I adore. It was the most wondrous portrayal of helpless feelings that are so strong and visceral, yet so essential to being a human, I thought. </p>
      
      <p>What struck me most was the profound significance of being stuck. Esther's paralysis wasn't just mental illness—it was the weight of too many choices, too many expectations, too many versions of herself she was supposed to be. That feeling of being frozen, unable to move forward but unable to go back, resonated so deeply with me, lots of times, between my current 24-year-old self and my 19-year-old one, at the time.</p>
      
        <p><strong><em>But then there were those moments—small, fragile moments—when clarity broke through.</em></strong> When Esther found glimpses of herself beneath all the noise. There's something so beautiful about the joy of figuring it out, even if just for a moment. That brief flash of understanding who you are and what you want, before the world tries to tell you otherwise again.</p>
      
      <p>Later, I found out that Sylvia wrote the book as a semi-autobigraphy, and that she had tried committing suicide many times before successfully doing so at the age of 30. This begs the question that I still don't know the answer for: does art have to be gloomy to be effective? I definitely muse over it several times in my life, and the different answers I have at different stages of my life seem to never be the end of it. I only know that right now, the answer is no, any story filled with emotions, be them happiness or sadness, is artful enough.</p>
      
      <p>Anyhow, The bell jar is a beautiful book and a mesmerizing work of art, and Sylvia Plath is one of my all-time favorite authors. Highly recommend!</p>
    `,
    author: "Thu Ngo",
    date: "2021-10-15",
    readTime: "6 min read",
    category: "thoughts",
    tags: ["reading", "sylvia plath", "books", "emotions"],
    featured: true,
    image: "/images/blog/restaurant-woman.jpg",
    alt: "Woman at restaurant with wine bottles in background, enjoying a cocktail",
    gridSize: "medium",
    blockType: "text-only"
  },
  {
    id: 2,
    title: "Zarna Garg's This American Woman",
    excerpt: "OMG, this screams me",
    content: `
      <p>My toxic trait is I love books that remind me of myself. And this one does it!!!!!</p>

      <p>Long story, a wonderful recounting of how an ambitious female navigates her own American Dream, and a longing to WIN. How relatable! Go read it people :)</p>
    `,
    author: "Thu Ngo",
    date: "2024-01-12",
    readTime: "1 min read",
    category: "thoughts",
    tags: ["books", "ambition", "american dream", "women", "reading"],
    featured: false,
    image: "/images/blog/zarna-book-cover.jpg",
    alt: "Zarna Garg's This American Woman book cover",
    gridSize: "small",
    blockType: "image-only"
  },
  {
    id: 3,
    title: "Doing hard things",
    excerpt: "brings you to the most wonderful feelings in the world",
    content: `
      <p>I have always been a die-hard fan of myself - and that is not an overstatement. I believe in confidence, of course, not arrogance. I also believe in hard work, and that you can achieve anything your heart desires by working hard. Recently, I discovered yet another thing about myself: I love doing hard things.</p>

      <p>Ever since I was a kid, I have been frantically chasing after the idea of being "perfect". Luckily or not, this "perfection" I wanted to attain was by my own design - my parents - the closest people to me as a child, never put any pressure on me. Perhaps because they cherished their little girl, perhaps because they were never educated enough to know what to desire, having never gone to college, but I took it as a good thing anyways - a gift of freedom. However, I did not arrive at this idea in the beginning, of course. Being born in a country where everyone was putting so much pressure on their children from a young age, I was clueless when having a completely different reality from my friends. As a competitive kid, I wanted the drive and pressure just as they had, to have more clarity on what to win over, but I had no idea.</p>

      <p>One day, I found something: I wanted to study abroad, and first, I had to be fluent in English, so I worked hard every single day to achieve that. I stopped hanging out with friends, being razor focused on the one goal that I finally accomplished; and it felt good. It was the first time I realized how competitive I was, and how much I wanted to win.</p>

      <p>Recently, I put two and two together and realized most, if not all, of my hobbies are doing difficult things, which a normal person grimaces at the thought of. I love biking, but especially uphill. I love doing yoga, but especially the power ones, when you hold a plank at least once for as long as you could. I love pilates, but especially advanced classes, although I struggle through every single one of them. I love running, but especially the ones that make me feel like I'm going to die and sweat like a pig. I love puzzles, especially those that take me hours to decode a piece. I love chess, especially when playing with my brother, who would defeat me without fail.</p>

      <p>And I love it. I love the feeling of pushing myself to my limits, and the feeling of accomplishment when I finally achieve something. I love the feeling of being in the zone, when I'm so focused on the task at hand that I forget about everything else. I love the shakes after an incredible power yoga session. I love the feeling of being so tired that I can't even lift my arms up to my head. Long story short, I discovered a while ago that I am a workaholic, but only recently that I am addicted even more to working on hard things.</p>

      <p>Of course, I barely ever find another person who is quite like me, but I don't mind being different. I think each person is unique, and we should all feel good about what makes us feel good. Personally, let me entice you to try something hard today, and let me know how it feels.</p>

      <p>For all of you weirdos enjoying challenges, <em>"May your trails be crooked, winding, lonesome, dangerous, leading to the most amazing view. May your mountains rise into and above the clouds."</em> - Edward Abbey.</p>
    `,
    
    
    author: "Thu Ngo",
    date: "2024-01-10",
    readTime: "2 min read",
    category: "personal",
    tags: ["mindfulness", "ritual", "peace"],
    featured: false,
    image: "/images/blog/contemplative-man.jpg",
    alt: "Contemplative man in thoughtful pose, hands clasped",
    gridSize: "small",
    blockType: "accent"
  },
  {
    id: 4,
    title: "we need a partner who",
    excerpt: "The qualities that truly matter",
    content: `
      <p><em>Coming soon...</em></p>
    `,
    author: "Thu Ngo",
    date: "2024-01-08",
    readTime: "2 min read",
    category: "thoughts",
    tags: ["relationships", "love", "partnership"],
    featured: false,
    image: "/images/blog/lifestyle-scene.jpg",
    alt: "Lifestyle scene with modern elements and contemporary atmosphere",
    gridSize: "medium",
    blockType: "image-only"
  },
  {
    id: 5,
    title: "making a rocket",
    excerpt: "Building dreams, one piece at a time",
    content: `
      <p><em>Coming soon...</em></p>
    `,
    author: "Thu Ngo",
    date: "2024-01-05",
    readTime: "2 min read",
    category: "learning",
    tags: ["dreams", "building", "persistence"],
    featured: true,
    image: "/images/blog/restaurant-woman.jpg",
    alt: "Woman at restaurant with wine bottles in background, enjoying a cocktail",
    gridSize: "small",
    blockType: "text-only"
  },
  {
    id: 6,
    title: "capturing moments",
    excerpt: "our similarities",
    content: `
      <p></p>
    `,
    author: "Thu Ngo",
    date: "2024-01-03",
    readTime: "3 min read",
    category: "personal",
    tags: ["photography", "art", "moments"],
    featured: false,
    image: "/images/blog/camera-man.jpg",
    alt: "Man with camera capturing a moment",
    gridSize: "medium",
    blockType: "image-only"
  },
  {
    id: 7,
    title: "urban reflections",
    excerpt: "Finding beauty in the city's rhythm",
    content: `
      <p><em>Coming soon...</em></p>
    `,
    author: "Thu Ngo",
    date: "2024-01-01",
    readTime: "2 min read",
    category: "thoughts",
    tags: ["city", "urban", "reflections"],
    featured: false,
    image: "/images/blog/urban-scene.jpg",
    alt: "Urban cityscape with architectural elements and street life",
    gridSize: "large",
    blockType: "accent"
  },
  {
    id: 8,
    title: "nature's embrace",
    excerpt: "Finding solace in the wild",
    content: `
      <p><em>Coming soon...</em></p>
    `,
    author: "Thu Ngo",
    date: "2023-12-28",
    readTime: "2 min read",
    category: "nature",
    tags: ["nature", "solitude", "peace"],
    featured: false,
    image: "/images/blog/nature-scene-1.jpg",
    alt: "Serene nature landscape with natural elements",
    gridSize: "medium",
    blockType: "image-only"
  },
  {
    id: 9,
    title: "coffee shop conversations",
    excerpt: "The art of people watching",
    content: `
      <p><em>Coming soon...</em></p>
    `,
    author: "Thu Ngo",
    date: "2023-12-25",
    readTime: "2 min read",
    category: "personal",
    tags: ["coffee", "community", "observations"],
    featured: false,
    image: "/images/blog/retro-cafe-woman.jpg",
    alt: "Woman in retro cafe setting with vintage atmosphere",
    gridSize: "small",
    blockType: "text-only"
  },
  {
    id: 10,
    title: "the mirror's truth",
    excerpt: "Reflections on self and identity",
    content: `
      <p><em>Coming soon...</em></p>
    `,
    author: "Thu Ngo",
    date: "2023-12-22",
    readTime: "2 min read",
    category: "thoughts",
    tags: ["identity", "reflection", "self-discovery"],
    featured: false,
    image: "/images/blog/outdoor-mirror.jpg",
    alt: "Outdoor mirror reflecting natural surroundings",
    gridSize: "medium",
    blockType: "accent"
  },
  {
    id: 11,
    title: "love in the city",
    excerpt: "Moments of connection in urban spaces",
    content: `
      <p><em>Coming soon...</em></p>
    `,
    author: "Thu Ngo",
    date: "2023-12-20",
    readTime: "1 min read",
    category: "personal",
    tags: ["love", "connection", "urban"],
    featured: false,
    image: "/images/blog/couple-kiss.jpg",
    alt: "Intimate moment between couple in urban setting",
    gridSize: "small",
    blockType: "image-only"
  },
  {
    id: 12,
    title: "the photographer's eye",
    excerpt: "Seeing the world differently",
    content: `
      <p><em>Coming soon...</em></p>
    `,
    author: "Thu Ngo",
    date: "2023-12-18",
    readTime: "2 min read",
    category: "art",
    tags: ["photography", "perspective", "art"],
    featured: false,
    image: "/images/blog/camera-person.jpg",
    alt: "Person with camera in artistic pose",
    gridSize: "medium",
    blockType: "text-only"
  },
  {
    id: 13,
    title: "city bear woman",
    excerpt: "Unexpected encounters in urban life",
    content: `
      <p><em>Coming soon...</em></p>
    `,
    author: "Thu Ngo",
    date: "2023-12-15",
    readTime: "2 min read",
    category: "thoughts",
    tags: ["urban", "encounters", "stories"],
    featured: false,
    image: "/images/blog/city-bear-woman.jpg",
    alt: "Urban scene with bear and woman in city setting",
    gridSize: "large",
    blockType: "accent"
  }
];

export const categories = [
  "all",
  "thoughts",
  "learning",
  "personal",
  "wisdom",
  "philosophy",
  "travel",
  "nature"
];

export const getFeaturedPosts = () => {
  return blogPosts.filter(post => post.featured);
};

export const getPostById = (id) => {
  return blogPosts.find(post => post.id === parseInt(id));
};